/**
 *
 * runtime config selectors
 *
 */

import { createSelector } from 'reselect';
import _get from 'lodash/get';

const selectConfig = (state) => state.appRuntimeConfig || {};

const makeSelectClipEndpoint = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'dataEndpoints.clip', '/video/data-service/videos/{contentId}')
    );
const makeSelectTopicEndpoint = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'dataEndpoints.topic', '/video/data-service/topic/{topicId}')
    );

const makeSelectListEndpoint = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'dataEndpoints.list', '/video/data-service/selection/{selectionSlug}?$limit=100')
    );

const makeSelectSearchEndpoint = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'dataEndpoints.search', 'https://www.mlb.com/data-service/en/search/')
    );

const makeSelectClub = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'club', 'mlb')
    );

const makeSelectIsClubPage = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'isClubPage', false)
    );

const makeSelectIsApp = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'isApp', false)
    );

const makeSelectBasePath = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'basePath', '/video')
    );

const makeSelectLang = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'lang', 'en')
    );

const makeSelectSuggestionsEndpoint = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'dataEndpoints.suggestions')
    );

const makeSelectLandingPageDisplayAdConfig = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'displayAdConfig.landingPage', {})
    );
const makeSelectPlaybackPageDisplayAdConfig = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'displayAdConfig.playbackPage', {})
    );
const makeSelectDefaultTopic = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'defaultTopic', 'top-videos')
    );
const makeSelectDictionary = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'dictionary', {})
    );
const makeSelectDeviceInfo = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'deviceInfo', {})
    );
const  makeSelectMboxes = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'mbox', {})
    );
const  makeSelectAdobeTargetConfig = () =>
    createSelector(
        selectConfig,
        (configState) => _get(configState, 'adobeTargetConfigClient', {})
    );    
// eslint-disable-next-line import/prefer-default-export
export {
    selectConfig,
    makeSelectClipEndpoint,
    makeSelectTopicEndpoint,
    makeSelectListEndpoint,
    makeSelectSearchEndpoint,
    makeSelectClub,
    makeSelectIsClubPage,
    makeSelectIsApp,
    makeSelectBasePath,
    makeSelectLang,
    makeSelectSuggestionsEndpoint,
    makeSelectLandingPageDisplayAdConfig,
    makeSelectPlaybackPageDisplayAdConfig,
    makeSelectDefaultTopic,
    makeSelectDictionary,
    makeSelectDeviceInfo,
    makeSelectMboxes,
    makeSelectAdobeTargetConfig,
};